import { StateProvider, StateService } from "@uirouter/angularjs";
import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementServiceProvider,
} from "../../../../../../../ui/authorizedUiElement";
import { UserProfile } from "../../../../../../../application/UserProfile";

export const vsServiceName = "machineDetailTabsService";
export const vsProviderName = `${vsServiceName}Provider`;

export class MachineDetailTabsProvider extends AuthorizedUiElementServiceProvider<AuthorizedUiElementConfig> {
  static $inject = ["$stateProvider"];

  constructor($stateProvider: StateProvider) {
    super($stateProvider);
  }

  override basePath: string = "main.machines.detail";

  override $get: any = [
    "userProfile",
    "$state",
    (userProfile: UserProfile, $state: StateService) => {
      return this.defaultServiceFactory(userProfile, $state);
    },
  ];
}
